import DialogService from './DialogService';
import Message from './Message.vue';
import Toast from './Toast.vue';
import { mount } from './utils';
import loggerService from '../logger.service';

import { getStore } from '@/utils/storeAccess';

class NotificationService {
  private el: HTMLElement | null;
  private userIdsHideNotification: Array<string>;

  constructor(elementId = 'notification-elements-wrapper') {
    this.el = document.getElementById(elementId);
    this.userIdsHideNotification = [
      '51c794bb-ab8b-4f47-960f-bde37b02e6ae',
      'd4578df7-0844-4a0f-aab1-b67f8621d76b',
      '2a4da913-d2a0-4558-a788-244ee1a84a2c'
    ];
  }

  toast(
    title: string,
    message: string,
    type: 'success' | 'warning' | 'error' = 'success',
    icon: string | null = null,
    duration: number | null = null,
    variables: object = []
  ) {
    const user = getStore()?.state.user.currentEventUser;
    if (this.userIdsHideNotification.includes(user?.id || '')) {
      return {
        promise: Promise.resolve(),
        close: () => {
          loggerService.info('NotificationService.toast: promise resolved');
        }
      };
    }

    const { promise, close } = mount(this.element, Toast, {
      title,
      message,
      type,
      icon,
      duration,
      variables
    });

    return { promise, close };
  }

  raise(component: any, props: any) {
    const { close } = mount(this.element, component, props);
    return close;
  }

  get element() {
    const el = document.createElement('div');

    if (this.el) {
      this.el.appendChild(el);
    }

    return el;
  }

  showMessage(payload: any) {
    return DialogService.show(Message, payload);
  }
}

export default new NotificationService();
